import { Controller } from "@hotwired/stimulus"

export default class MenuController extends Controller {
  connect() {
    this.trigger = this.element.querySelector('.menu__trigger');
    this.dropdown = this.element.querySelector('.menu__dropdown');

    if (!this.trigger || !this.dropdown) return;

    this.boundHandleClickAway = this.handleClickAway.bind(this);
    this.boundHandleResize = this.handleResize.bind(this);

    this.trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      this.toggle();
    });

    document.addEventListener('click', this.boundHandleClickAway);
    window.addEventListener('resize', this.boundHandleResize);
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickAway);
    window.removeEventListener('resize', this.boundHandleResize);
  }

  handleClickAway(event) {
    const elementContainsTarget = this.element.contains(event.target);
    if (!elementContainsTarget && this.element.classList.contains('open')) {
      this.close();
    }
  }

  handleResize() {
    // Close menu on window resize
    if (this.element.classList.contains('open')) {
      this.close();
    }
  }

  toggle() {
    if (this.element.classList.contains('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.element.classList.add('open');
  }

  close() {
    this.element.classList.remove('open');
  }
}
